(function () {
  initializeUtilsFunctions();
  executeOnce('rental', function () {
    function getRentalNews() {
      const categoryRentalId = document.getElementById('rental--news');
      if (categoryRentalId) {
        const uri =
          '/api/categoryNews/' + categoryRentalId.getAttribute('data-category');

        callApi({
          uri: window.location.origin + sanitizeUri(uri),
          method: 'GET',
        })
          .then((response) => {
            const newsContainer = document.querySelector(
              '.rental--news--container',
            );
            if (response.data.length && newsContainer) {
              newsContainer.classList.remove('hidden');
            }
            response.data.forEach((tile) => {
              if (newsContainer) {
                const clone = newsContainer
                  .querySelector('.card-to-clone')
                  .cloneNode(true);
                clone.querySelectorAll('.link').forEach((link) => {
                  link.title = tile.field_title;
                  link.href = tile.url;
                });
                clone.querySelector('.content').innerHTML = tile.field_subtitle;
                if (!!tile.field_tags) {
                  tile.field_tags.forEach((tag) => {
                    const t = document.createElement('div');
                    t.innerText = tag;
                    clone.querySelector('.tags div').append(t);
                  });
                }
                clone.querySelector('.card--news--content--title a').innerHTML =
                  tile.field_title;
                if (!!tile.image) {
                  clone.querySelector('.image-container').style.cssText =
                    "background-image:url('" + tile.image + "')";
                }
                clone.classList.remove('hidden');
                newsContainer
                  .querySelector('.rental-news-container--list')
                  .appendChild(clone);
              }
            });
            if (
              newsContainer &&
              newsContainer.querySelector('.rental-news-container--list') &&
              document
                .querySelector('.rental-news-container--list')
                .querySelector('.hidden')
            ) {
              newsContainer
                .querySelector('.rental-news-container--list')
                .removeChild(
                  document
                    .querySelector('.rental-news-container--list')
                    .querySelector('.hidden'),
                );
            }
            if (
              document.querySelectorAll('.rental-news-container--list') &&
              document.querySelectorAll('.rental-news-container--list').length
            ) {
              const carouselsRelatedNews = document.querySelectorAll(
                '.rental-news-container--list',
              );
              new Glider(carouselsRelatedNews[0], {
                itemWidth: 390,
                exactWidth: true,
                draggable: true,
                dots: '.rental-news-container--dots',
                responsive: [
                  {
                    // screens greater than >= 775px
                    breakpoint: 500,
                    settings: {
                      slidesToScroll: 4,
                      slidesToShow: 4,
                    },
                  },
                ],
              });
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
      }
    }

    getRentalNews();
  });
})();
